import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BiometricService } from 'src/app/contexts/biometric/infraestructure/services/biometric.service';
import { environment } from 'src/environments/environment';
import { B2cService } from '../../../infraestructure/services/b2c.service';
import { MessageError } from 'src/app/contexts/login/infrastructure/core/components/error/message-error';
import { ErrorMessageFactory } from 'src/app/contexts/login/infrastructure/core/components/error/error-message-factory';
import { SessionStorageRepository } from 'src/app/contexts/shared/storage/session-storage.repository';
import { BcpSessionStorage } from '@bcp/js-storage';
import { CHATBOT_IDENTIFIERS, CHATBOT_STORAGE_KEY } from 'src/app/contexts/shared/constants/chatbot.constants';

@Component({
  selector: 'app-verification-login',
  templateUrl: './verification-login.component.html',
  styleUrls: ['./verification-login.component.scss']
})
export class VerificationLoginComponent {
  private sessionStorageRepository = new SessionStorageRepository(new BcpSessionStorage());

  @ViewChild('loaderIndicator') loaderIndicator! : ElementRef<any> | undefined;

  isLoading : boolean = true; 
  isValidation : boolean = false;
  isErrorAuthentication : boolean = false;
  messageLoading : string = 'Un momento más por favor';
  isMessageError : boolean = false;
  
  private readonly errorMessageFactory = new ErrorMessageFactory();
  messageError: MessageError = this.errorMessageFactory.errorConnection();
  code: string | null = null;
 

  constructor(private route:ActivatedRoute, private http: HttpClient,private b2cService : B2cService,
    private biometricService : BiometricService
  ) { 
    this.route.queryParamMap.subscribe(params => {
      this.code = params.get('code');
    });

  }

  async ngAfterViewInit(){   
    this.openLoaderIndicator(); 
    try {

      this.isErrorAuthentication = this.biometricService.errorAuthentication();

      if(this.isErrorAuthentication){
        this.invalidateError();
        return;
      }

      const response = await this.b2cService.getDataB2c(this.code);  
      if(response){
        this.closeLoaderIndicator();
        this.isLoading = true;
        this.isValidation = true;
        setTimeout( () =>{  this.validationTrue();  },3000);
      }else{
        this.invalidateError();
      }

    } catch (error : any) { 
      this.invalidateError();
      if(error?.status == 409){
        this.messageError = this.errorMessageFactory.linkError();
      }
    }
  }

  invalidateError(){
    this.isMessageError = true; 
    this.biometricService.invalide();
    this.closeLoaderIndicator();
  }

  validationTrue(){
    this.isValidation = false;
    this.isLoading = false; 
    this.isMessageError = true;
    const chatbotId = this.sessionStorageRepository.find(CHATBOT_STORAGE_KEY) ?? CHATBOT_IDENTIFIERS.AS_IS;
    const subtitle = chatbotId === CHATBOT_IDENTIFIERS.ADVISOR_AUTHENTICATION
      ? 'Ya puedes continuar con tu asesor en el Whatsapp del BCP'
      : 'Ya puedes seguir con tus consultas en el Whatsapp del BCP';

    const description = chatbotId === CHATBOT_IDENTIFIERS.ADVISOR_AUTHENTICATION
      ? 'En breve llegará una notificación a tu Whatsapp en la que se confirma la validación de tu identidad.'
      : 'En breve te llegará una notificación a tu Whatsapp confirmando tu inicio de sesión';

    const textBtn = chatbotId === CHATBOT_IDENTIFIERS.ADVISOR_AUTHENTICATION ? 'Continuar con mi asesor' : 'Entendido';

    this.messageError = {
      urlImg: '/assets/svg/success_img.svg',
      altTxtImg: 'Éxito de validación de usuario',
      title: '¡Felicitaciones!',
      subtitle,
      description,
      textBtn,
      style: '',
      redirectTo: `https://wa.me/${environment.NumberWsp}`,
    };
    this.biometricService.clearDataBiom();
    this.b2cService.clearDataB2c();
  }

  openLoaderIndicator() {
    this.loaderIndicator?.nativeElement.open(); 
  }

  closeLoaderIndicator() {
    this.isLoading = false;
    this.loaderIndicator?.nativeElement.close(); 
  }

  redirectSend(redirectTo: string | null) {
    if (redirectTo) {
      window.open(redirectTo, '_blank', 'noopener');
    }
  }
}
